export const paginator = (items, currentPage, perPageItems) => {
  const page = currentPage || 1;
  const perPage = perPageItems || 10;
  const offset = (page - 1) * perPage;

  const paginatedItems = items.slice(offset).slice(0, perPageItems);
  const totalPages = Math.ceil(items.length / perPage);

  return {
    data: paginatedItems,
    nextPage: totalPages > page ? page + 1 : null,
    page,
    perPage,
    prePage: page - 1 ? page - 1 : null,
    total: items.length,
    totalPages,
  };
};

export const sortBySelected = (x, y) =>
  // eslint-disable-next-line no-nested-ternary
  x.selected === y.selected ? 0 : x.selected ? -1 : 1;

export const sortByOrder = (arrayTestimonies) =>
  Array.from(arrayTestimonies).sort((x, y) => x.order - y.order);

export const deepClone = (array = []) => JSON.parse(JSON.stringify(array));
